import React, { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { SidebarProvider } from "@/components/ui/sidebar";
import { useAuth } from "@/hooks/useAuth";
import { supabase } from "@/lib/supabaseClient";
import AdminSidebar from "@/components/admin/dashboard/AdminSidebar";
import MainContent from "@/components/admin/dashboard/MainContent";
import LoadingSpinner from "@/components/admin/dashboard/LoadingSpinner";
import AdminHeader from "@/components/admin/AdminHeader";
import { isBrowser } from "@/utils/runtime";

const AdminDashboard: React.FC = () => {
  const { session, loading } = useAuth();
  const user = session?.user ?? null;
  const [activeModule, setActiveModule] = useState("dashboard");
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    if (isBrowser) {
      setMounted(true);
    }
  }, []);

  if (loading || !mounted) {
    return <LoadingSpinner />;
  }

  if (!session) {
    return <Navigate to="/admin-login" replace />;
  }

  const handleLogout = async () => {
    await supabase?.auth.signOut();
  };

  return (
    <SidebarProvider>
      <div className="flex min-h-screen w-full bg-gray-50">
        <AdminSidebar
          activeModule={activeModule}
          setActiveModule={setActiveModule}
          user={user}
          handleLogout={handleLogout}
        />
        
        {/* Main Content */}
        <div className="flex-1">
          <AdminHeader />
          <main className="min-h-screen">
            <MainContent 
              activeModule={activeModule} 
              setActiveModule={setActiveModule} 
            />
          </main>
        </div>
      </div>
      <Toaster position="top-right" />
    </SidebarProvider>
  );
};

export default AdminDashboard;
